import React from 'react';

import cx from '../../utils/classnames';

import styles from './tooltip.module.scss';

import type { ReactNode, HTMLProps } from 'react';

type Props = {
  className?: string;
  children?: ReactNode | string;
} & HTMLProps<HTMLDivElement>;

export default function Tooltip(props: Props) {
  const { className, ...rest } = props;

  return (
    <div className={cx(className, styles.tooltip)} data-testid="tooltip-div-wrapper" {...rest}>
      <div className={styles.text}>{props.children}</div>
    </div>
  );
}
